import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { class: "text-gray-400" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = { class: "text-gray-400" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_11 = { class: "mb-1 text-nowrap" }
const _hoisted_12 = { class: "text-gray-400" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { colspan: "11" }
const _hoisted_18 = { class: "d-flex flex-column justify-content-center align-items-center h-60px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_product = _resolveComponent("common-product")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (row, j) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: _normalizeClass(["subtable_template order-request text-start border-dashed", {
      'border-0': j === _ctx.tableData.length - 1,
    }]),
        key: j
      }, [
        _createVNode(_component_common_product, {
          gallery: [
        {
          id: 0,
          origin_url: row.__show.product_gallery,
        },
      ],
          brand_id: row.brand_name,
          brand_article_no: row.article_no,
          product_identifier_id: '0',
          source_link: '',
          name: row.__show.product_name,
          name_en: row.__show.product_name,
          color: row.color,
          size: row.size,
          productCol: 2,
          skuCol: 2
        }, null, 8, ["gallery", "brand_id", "brand_article_no", "name", "name_en", "color", "size"]),
        _createElementVNode("td", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("order.unitPrice")), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(row.__show.currency_code == "￥"
              ? _ctx.$currency.currency(
                  Number(row.__show.sub_total) / row.__show.qty,
                  2,
                  ".",
                  "",
                  row.__show.currency_code
                )
              : _ctx.$currency.currency(
                  Number(row.__show.sub_total) / row.__show.qty,
                  2,
                  ",",
                  ".",
                  row.__show.currency_code
                )), 1)
          ])
        ]),
        _createElementVNode("td", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t("order.qty")), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(row.__show.qty), 1)
          ])
        ]),
        _createElementVNode("td", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("order.subTotal")), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(row.__show.currency_code == "￥"
              ? _ctx.$currency.currency(
                  row.__show.sub_total,
                  2,
                  ".",
                  "",
                  row.__show.currency_code
                )
              : _ctx.$currency.currency(
                  row.__show.sub_total,
                  2,
                  ",",
                  ".",
                  row.__show.currency_code
                )), 1)
          ])
        ]),
        _hoisted_13,
        _hoisted_14,
        _hoisted_15
      ], 2))
    }), 128)),
    (_ctx.tableData.length == 0)
      ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_16, [
          _createElementVNode("td", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.isRequest ? "No data found" : ""), 1)
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true)
  ], 64))
}